<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <h5 class="card-title center">Permisos Modulo {{ module.module_label }}</h5>
          <h6 class="card-subtitle mb-5 text-muted center">{{ module.module_description }}</h6>
          <form v-if="$can('create', 'Permissions')">
            <div class="form-row">
              <div class="col">
                <div class="form-group">
                  <label for="inlineFormInputAction">* Accion</label>
                  <input type="text" v-model="input.action" class="form-control mb-2 mr-sm-2" id="inlineFormInputAction" placeholder="read">
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label for="inlineFormInputSubject">* Sujeto</label>
                  <input type="text" v-model="input.subject" class="form-control mb-2 mr-sm-2" id="inlineFormInputSubject" placeholder="Modulo">
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label for="inlineFormInputContiditions">Condiciones</label>
                  <input type="text" v-model="input.conditions" class="form-control mb-2 mr-sm-2" id="inlineFormInputContiditions" placeholder="{ roleId: user.role_id }">
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label for="inlineFormInputDescription">* Descripcion</label>
                  <input type="text" v-model="input.description" class="form-control mb-2 mr-sm-2" id="inlineFormInputDescription" placeholder="Leer el modulo del role asigando">
                </div>
              </div>
            </div>
            <div class="form-row mb-3">
              <div class="col center">
                <a href="https://casl.js.org/v4/en/guide/intro" target="blank">Mas informacion</a>
              </div>
            </div>
            <div class="form-row">
              <div class="col center">
                <button type="button" class="btn btn-primary mb-2" @click="addPermission">Agregar</button>
              </div>
            </div>
          </form>
          <hr>
          <b-table
            show-empty
            stacked="md"
            :fixed="true"
            :borderless="true"
            :items="items"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import axiosAdelaService from '@/axios/axiosAdelaService'
import formatData from '@/mixins/formatAxios'

export default {
  mixins: [formatData],
  components: {
    BTable
  },
  data () {
    return {
      input: {
        action: '',
        subject: '',
        conditions: '',
        description: ''
      },
      module: {},
      items: [],
      fields: [
        { key: 'action', label: 'Accion', sortable: true, sortDirection: 'desc' },
        { key: 'subject', label: 'Sujeto' },
        { key: 'conditions', label: 'Condiciones' },
        { key: 'description', label: 'Descripcion' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 50,
      pageOptions: [50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null
    }
  },
  methods: {
    validPermission () {
      return !this.$_.isEmpty(this.input.action) && !this.$_.isEmpty(this.input.subject) && !this.$_.isEmpty(this.input.description)
    },
    async addPermission () {
      if (this.validPermission()) {
        try {
          const request = {
            ...this.input,
            adminModuleId: this.module.admin_module_id
          }
          const response = await axiosAdelaService.post('/addModulePermission', request)
          if (response.status === 200) {
            this.items.push({
              ...this.input
            })
            this.$toastedPush({
              message: 'Se agrego el nuevo modulo.',
              type: 'success'
            })
          }
        } catch (error) {
          this.showError('No se pudo agregar el modulo, intentalo mas tarde')
        }
      } else {
        this.showError('Los campos marcados con * son obligatorios')
      }
    }
  },
  async mounted () {
    try {
      const items = {
        moduleId: this.module.admin_module_id
      }
      const response = await axiosAdelaService.post('/getModulePermissions', items)
      if (response.status === 200) {
        this.items = response.data
      }
    } catch (error) {
      this.showError('No se pudieron obtener los modulos intentalo mas tarde.')
    }
  },
  created () {
    this.module = {
      ...this.$_.get(this.$route, 'params.row', 0)
    }
  }
}
</script>

<style>

</style>
